<template>
<div class="chapter">
<div class="inner_page">
<a id="pagei">
<p class="half_t">FOLLOWING IN THE FOOTSTEPS OF</p>
<p class="half_t1">OLIVER CROMWELL</p>
</a><a id="pageii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 00_Half_title.vue?1a9252d7